// Additional terminology, safer-sleep and inclusive-address draft QA changes.
export default {
  "bn": {
    "words.scbu.meaning": "বিশেষ নবজাতক পরিচর্যা ইউনিট (SCBU): যেসব নবজাতকের অতিরিক্ত চিকিৎসা বা নার্সিং সহায়তা প্রয়োজন, কিন্তু নিয়মিত নিবিড় পরিচর্যার প্রয়োজন নেই, তাদের এখানে সেবা দেওয়া হয়।"
  },
  "fr": {
    "modules.preparing-home.topics.safety.paragraphs.1": "Dormir dans le même lit que son bébé présente un risque particulièrement élevé si le bébé est né prématurément ou avec un faible poids de naissance. Les positions utilisées sous surveillance étroite à l’hôpital ne conviennent pas nécessairement à la maison. Suivez les consignes particulières de l’équipe qui soigne votre bébé."
  },
  "ar": {
    "stages.feeding.explanation.variationNote": "يُرجى عدم تغيير كميات الرضعات أو مواعيدها أو طريقة تحضير الحليب أو المعدات المستخدمة دون استشارة فريق رعاية طفلكم. قد تختلف خطة تغذية طفلكم عن الإرشادات العامة للمواليد الجدد."
  }
};
